import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards]);
document.addEventListener('DOMContentLoaded', function() {


    var svw = jQuery('.swiper-container').attr('data-swiper-slidesperview') ? jQuery('.swiper-container').attr('data-swiper-slidesperview') : 1 ;
    var hasnav = jQuery('.swiper-container').attr('data-swiper-navigation') == 1 ? true : false ;
    var haspag = jQuery('.swiper-container').attr('data-swiper-pagination') == 0 ? false : true ;
    var isloop = jQuery('.swiper-container').attr('data-swiper-loop') == 0 ? false : true ;
    var params_arr = {
        effect: 'slide',
        loop: true,
        pagination: false,
        slidesPerView: 1,
        navigation: false,
        breakpoints: {
            // when window width is >= 320px
            1199: {
              slidesPerView: svw,
            },

            600: {
              slidesPerView: 2,
            },
        }
      };
if (hasnav) {
 params_arr.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };

}

if (isloop) {
 params_arr.loop = true;
        params_arr.autoplay= {delay: 5000};
}

if (haspag) {
 params_arr.pagination = {
          el: '.swiper-pagination',
        };
}

    var swiper = new Swiper('.swiper-container', params_arr);

});
